/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Choose_FileInputs */

const vi_import_choose_file = /** @type {(inputs: Import_Choose_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn file Excel (.xlsx)`)
};

/**

* @param {Import_Choose_FileInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_choose_file = /** @type {((inputs?: Import_Choose_FileInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Choose_FileInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_choose_file(inputs)
});